import { environmentHttpClient } from "client/Api/httpClient";

export type VilansKickSubject = {
	id: string;
	title: string;
};

export const enum VilansKickItemKind {
	Unknown = 0,
	WorkInstruction = 1,
	BackgroundInformation = 2
}

export type VilansKickItem = {
	id: number;
	title: string;
	url: string;
	kind: VilansKickItemKind;
};

export function listSubjects(
	connectionId: number,
	signal?: AbortSignal
): Promise<readonly VilansKickSubject[]> {
	return environmentHttpClient.get<readonly VilansKickSubject[]>(
		`/Workspace/LiveInformation/VilansKick/${connectionId}/Subjects`,
		null,
		{ signal }
	);
}

export function listItemsBySubject(
	connectionId: number,
	subjectId: string,
	signal?: AbortSignal
): Promise<readonly VilansKickItem[]> {
	return environmentHttpClient.get<readonly VilansKickItem[]>(
		`/Workspace/LiveInformation/VilansKick/${connectionId}/Subjects/${encodeURIComponent(subjectId)}/Items`,
		null,
		{ signal }
	);
}

export function search(
	connectionId: number,
	searchTerm: string,
	signal?: AbortSignal
): Promise<readonly VilansKickItem[]> {
	return environmentHttpClient.get<readonly VilansKickItem[]>(
		`/Workspace/LiveInformation/VilansKick/${connectionId}/Items/Search`,
		{
			searchTerm
		},
		{ signal }
	);
}